import { gql } from "@apollo/client";

export const GET_HOME_TODO_GROUP_ITEMS = gql`
  query HomeTodoGroupItems($params: HomeTodoGroupItemsParams!) {
    homeTodoGroupItems(params: $params) {
      items {
        deductionId
        remittanceItemId
        checkNumber
        invoiceNumber
        purchaserName
        amount
        age
        priorityKey
        deductionType
        deductionTypeKey
        statusKey
        daysLeft
      }
      total
      page
      limit
      categoryKey
    }
  }
`;
